const state = () => ({
    data: [],
    pagination: {
        total_page: null,
        total_record: null,
        page: 1,
        page_limit: 24,
    }
})

// getters
const getters = {}

// actions
const actions = {
    // get videos
    async get({state, commit, rootState}, {directory_id, filter, pagination, sort} = {}) {

        const res = await this._vm.axios.get(this._vm.endpoint.get('library_video'), {
            params: {
                directory_id: directory_id ?? 0,
                sort: sort ?? 'created_at:desc',
                ...pagination,
                ...filter
            }
        })

        // istek uçuştayken klasör değiştiyse bayat cevabı state'e yazma
        if (String(rootState.library.currentId ?? 0) !== String(directory_id ?? 0)) {
            return false
        }

        const {data} = res.data

        commit('setData', data)
        commit('setPagination', res.data.meta)

        return true
    },

    // show video
    async show(_, {id}) {
        try {
            const res = await this._vm.axios.get(this._vm.endpoint.get('library_video') + '/' + id)

            return res.data
        } catch (error) {
            throw error.response?.data || error
        }
    },

    // update video
    async save(_, {data}) {
        try {
            const res = await this._vm.axios.put(this._vm.endpoint.get('library_video') + '/' + data.id, data)

            return res.data
        } catch (error) {
            throw error.response?.data || error
        }
    },

    // upload video
    async uploadVideos({commit}, {data}) {
        const results = [];

        for (const video of data.videos) {
            const formData = new FormData();
            // group_id şu anlık zorunlu lakin bu zorunluluk kalkacak.
            formData.append('group_id', "627");
            formData.append('file', video.file);
            formData.append('title', video.title);
            formData.append('convert_hls', data.convert_hls ? '1' : '0');
            formData.append('convert_unsupported', data.convert_unsupported ? '1' : '0');

            if (data.directory_id) {
                formData.append('directory_id', data.directory_id);
            }

            const res = await this._vm.axios.post(this._vm.endpoint.get('library_video'), formData);
            results.push(res.data);

            if (!res.data.status) {
                throw res.data;
            }
        }

        return {status: true};
    },

    // move video
    async moveVideo({commit}, {data}) {
        try {
            const res = await this._vm.axios.put(
                this._vm.endpoint.get('library_video') + '/' + data.id,
                {
                    ...data
                }
            )

            return res.data
        } catch (error) {
            throw error.response?.data || error
        }
    },

    // delete video
    async delete({commit}, {data}) {
        try {
            const res = await this._vm.axios.delete(this._vm.endpoint.get('library_video') + '/' + data.id)

            return res.data
        } catch (error) {
            throw error.response?.data || error
        }
    },

}

// mutations
const mutations = {
    setData(state, data) {
        state.data = data
    },
    setPagination(state, pagination) {
        state.pagination.page = pagination.current_page
        state.pagination.page_limit = pagination.per_page
        state.pagination.total_page = pagination.total_page
        state.pagination.total_record = pagination.total_record
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
